export { default } from './grn-factory-check';
